import { TFunction } from "i18next";

export const getPlanTypeOptions = (t: TFunction) => [
  {
    value: "EARLY",
    label: t("backoffice.pageModalSetDefaultPlanTypeEarly"),
  },
  {
    value: "TIMELINE",
    label: t("backoffice.pageModalSetDefaultPlanTypeTimeline"),
  },
];
